/** @format */

import { ProductSummarisedFeature, SelectedProductReviewsProsCons } from '../../model';
import { createAction, props } from '@ngrx/store';

/**
 * Action types initialization
 */
export enum ProductReviewProsConsActionTypes {
	REMOVE_SELECTED_FEATURE = '[Product Reviews Pros Cons] Remove Selected Feature',
	SET_PRODUCT_REVIEW_CONS = '[Product Reviews Pros Cons] Set Product Review Cons',
	SET_PRODUCT_REVIEW_PROS = '[Product Reviews Pros Cons] Set Product Review Pros',
	SET_PRODUCT_REVIEW_PROS_CONS = '[Product Reviews Pros Cons] Set Product Review Pros Cons',
	SET_SELECTED_FEATURE = '[Product Reviews Pros Cons] Set Selected Feature'
}

/**
 * Actions initialization
 */
export const setProductReviewCons = createAction(
	ProductReviewProsConsActionTypes.SET_PRODUCT_REVIEW_CONS,
	props<{ cons: ProductSummarisedFeature[] }>()
);

export const setProductReviewPros = createAction(
	ProductReviewProsConsActionTypes.SET_PRODUCT_REVIEW_PROS,
	props<{ pros: ProductSummarisedFeature[] }>()
);

export const setProductReviewProsCons = createAction(
	ProductReviewProsConsActionTypes.SET_PRODUCT_REVIEW_PROS_CONS,
	props<{ cons: ProductSummarisedFeature[]; pros: ProductSummarisedFeature[] }>()
);

export const setSelectedFeature = createAction(
	ProductReviewProsConsActionTypes.SET_SELECTED_FEATURE,
	props<{ selectedFeature: SelectedProductReviewsProsCons }>()
);

export const removeSelectedFeature = createAction(
	ProductReviewProsConsActionTypes.REMOVE_SELECTED_FEATURE
);
